(() => {
  const body = document.body;
  const hero = document.querySelector('.islander-home-hero');
  const footer = document.querySelector('footer');
  const visibleClass = 'islander-floating-actions-visible';
  const footerHiddenClass = 'islander-floating-workshop-footer-hidden';
  let revealThreshold = 160;
  let frameRequested = false;

  const calculateThreshold = () => {
    if (!hero) {
      revealThreshold = 160;
      return;
    }

    const heroHeight = hero.getBoundingClientRect().height || window.innerHeight;
    revealThreshold = Math.max(160, Math.min(heroHeight * 0.36, 320));
  };

  const updateVisibility = () => {
    frameRequested = false;
    body.classList.toggle(visibleClass, window.scrollY >= revealThreshold);
  };

  const requestVisibilityUpdate = () => {
    if (frameRequested) return;

    frameRequested = true;
    window.requestAnimationFrame(updateVisibility);
  };

  const handleResize = () => {
    calculateThreshold();
    requestVisibilityUpdate();
  };

  calculateThreshold();
  updateVisibility();
  window.addEventListener('scroll', requestVisibilityUpdate, { passive: true });
  window.addEventListener('resize', handleResize, { passive: true });

  if (hero && 'ResizeObserver' in window) {
    new ResizeObserver(handleResize).observe(hero);
  }

  if (footer && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      body.classList.toggle(footerHiddenClass, entry.isIntersecting);
    }, { threshold: 0.01 }).observe(footer);
  }
})();

(() => {
  const bookingTrigger = document.querySelector('[data-fareharbor-src]');
  if (!bookingTrigger) return;

  const bookingLinks = document.querySelectorAll('a[href*="fareharbor.com/embeds/book/"]');

  const loadFareHarbor = () => {
    if (window.IslanderFareHarborPromise) return window.IslanderFareHarborPromise;

    window.IslanderFareHarborPromise = new Promise((resolve) => {
      const source = bookingTrigger.dataset.fareharborSrc;
      const existingScript = document.querySelector(`script[src="${source}"]`);
      if (existingScript) {
        resolve(existingScript);
        return;
      }

      const script = document.createElement('script');
      script.src = source;
      script.async = true;
      script.addEventListener('load', () => resolve(script), { once: true });
      script.addEventListener('error', () => resolve(null), { once: true });
      document.head.appendChild(script);
    });

    return window.IslanderFareHarborPromise;
  };

  ['pointerenter', 'focus', 'touchstart'].forEach((eventName) => {
    bookingLinks.forEach((bookingLink) => {
      bookingLink.addEventListener(eventName, loadFareHarbor, {
        once: true,
        passive: eventName === 'touchstart',
      });
    });
  });
})();
